import { render, staticRenderFns } from "./MbgChartPicker.vue?vue&type=template&id=da18acac&"
import script from "./MbgChartPicker.vue?vue&type=script&lang=js&"
export * from "./MbgChartPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports